<template>
    <div class="col-12 row">
        <div class="col-9 row">
            <treeselect
                valueFormat="object"
                v-model="currentSelected"
                :multiple="false"
                :async="true"
                :load-options="loadOptions"
                :clear-on-select="true"
                ref="select"

                :placeholder="currentLang.placeholder"
                :retryTitle="currentLang.retryTitle"
                :retryText="currentLang.retryText"
                :noOptionsText="currentLang.noOptionsText"
                :noResultsText="currentLang.noResultsText"
                :noChildrenText="currentLang.noChildrenText"
                :searchPromptText="currentLang.searchPromptText"
                :clearValueText="currentLang.clearValueText"
                :clearAllText="currentLang.clearAllText"
            ></treeselect>
            </div>
        <div class="col-2 row" v-show="showButtons">
            <a @click="openCreate()" class="mt0 btn btn-success small primary ml5" target="_blank">
                <i class="fa fa-plus"></i>
            </a>

            <a v-show="currentSelected" @click="openEdit()" class="mt0 btn btn-secondary small yellow ml5">
                <i class="fa fa-edit"></i>
            </a>
        </div>
        <div v-if="currentSelected && showButtons" class="col-12 mt5 paragraph alert alert-danger" v-show="!currentSelected.has_addresses">
            <span>Let op: deze klant heeft nog geen adressen opgeslagen, klik <a target="_blank" class="boldFont" :href="routeAddress">hier</a> om deze aan te maken</span>
        </div>
        <input type="hidden" name="selected_debtor" v-model="encodedData" />
    </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'

import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {EventBus} from "../../events";

export default {
    components: {
        Treeselect
    },
    props: {
        selected: {
            required: false,
        },
        routeCreate: {
            required: false,
            type: String,
            default: "",
        },
        showButtons: {
            required: false,
            default: true,
        }
    },
    data: function () {
        return {
            currentLang: {
                'placeholder': 'Selecteer',
                'retryTitle': 'Klik om opnieuw te proberen',
                'retryText': 'Opnieuw proberen?',
                'noOptionsText': 'Geen opties gevonden.',
                'noResultsText': 'Geen resultaten gevonden...',
                'noChildrenText': 'No sub-options.',
                'searchPromptText': 'Typ om te zoeken...',
                'clearValueText': 'Leeg maken',
                'clearAllText': 'Leeg maken'
            },
            currentSelected: null,
            currentOptions: [],
        }
    },
    methods: {
        loadOptions: _.debounce(({action, searchQuery, callback}) => {
            axios.get(`/api/backend/debtors/?search=${searchQuery}`)
            .then(response => {
                let options = [];
                if (response.data) {
                    options = response.data.data.map(i => ({
                        id: `${i.id}`,
                        contact_id: `${i.contact_id}`,
                        label: `${i.name}`,
                        edit_route: `${i.edit_route}`,
                        address_route: `${i.address_route}`,
                        has_addresses: i.has_addresses
                    }));
                }
                callback(null, options)
            });
        }, 500),
        changeLang() {
            _.forEach(this.lang, (value, key) => {
                this.currentLang[key] = value;
            });
        },
        openEdit() {
            $('body').removeClass('addressCreate');
            $.fancybox.open({
                src: '/debtors/popup/'+this.currentSelected.id+'/edit/',
                type: 'iframe'
            });
        },
        openCreate() {
            $('body').removeClass('addressCreate');
            $.fancybox.open({
                src: '/debtors/popup/create/',
                type: 'iframe'
            });
        },
    },
    watch: {
        iframeData: function(newData, oldData) {
            if(newData != null) {
                this.currentSelected = iframeData;
                this.currentSelected.label = iframeData.name;
            }
        },
        currentSelected: function(newId){
            EventBus.$emit('changeDebtor', newId);
        }
    },
    computed: {
        encodedData() {
            return JSON.stringify(this.currentSelected);
        },
        routeEdit() {
            return this.currentSelected ? this.currentSelected.edit_route : '';
        },
        routeAddress() {
            return this.currentSelected ? this.currentSelected.address_route : '';
        },
        iframeData () {
            return window.iframeData;
        }
    },
    mounted() {

        if(this.selected != "") {
            this.currentSelected = {
                id: this.selected.id,
                label: this.selected.label
            };
        }

        this.changeLang();
    },
    created() {
    }

}
</script>

<style type="text/css">
.vue-treeselect__single-value{
    font-size: 14px;
}
</style>
